// src/utils/getFeatureCollectionLineString.ts
import { FeatureCollection, LineString, MultiLineString, Position } from 'geojson';

/**
 * Extracts every coordinate pair from LineString and MultiLineString
 * geometries inside a GeoJSON FeatureCollection.
 *
 * @param featureCollection A valid GeoJSON FeatureCollection
 * @returns All `[lon, lat]` (or `[lon, lat, alt]`) positions, or `null` if none found
 */
export function getFeatureCollectionLineString(
  featureCollection: FeatureCollection
): Position[] | null {
  if (!featureCollection?.features) return null;

  const coordinates: Position[] = [];

  for (const feature of featureCollection.features) {
    const geom = feature.geometry;
    if (!geom) continue;

    // ---- Handle simple LineString ----------------------------------------
    if (geom.type === 'LineString') {
      (geom as LineString).coordinates.forEach((coord) => {
        if (Array.isArray(coord) && coord.length >= 2) {
          coordinates.push(coord);
        }
      });

      // ---- Handle MultiLineString -----------------------------------------
    } else if (geom.type === 'MultiLineString') {
      (geom as MultiLineString).coordinates.forEach((line) => {
        if (Array.isArray(line)) {
          line.forEach((coord) => {
            if (Array.isArray(coord) && coord.length >= 2) {
              coordinates.push(coord);
            }
          });
        }
      });
    }
  }

  return coordinates.length > 0 ? coordinates : null;
}
